/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from 'mbp-api-util';

const getLoggingServiceEndpointURL = () => {
    const isSSR = typeof window === 'undefined';

    let protocol;
    if (isSSR) {
        protocol = process.env.APP_WC_PROTOCOL_SSR || 'http';
    } else {
        protocol =  mbpUtil.getEnv('APP_WC_PROTOCOL') || 'https';
    }

    let host;
    if (isSSR) {
        host = 'mbp-logger-splunk.common-services.svc.cluster.local:8080';
    } else {
        host = mbpUtil.getEnv('REACT_APP_MBP_LOGGER_HOST') || window.location.hostname;
    }

    let path;
    if (isSSR) {
        path = 'logging/mbp-ui';
    } else {
        path = 'r/api/logging/mbp-ui';
    }

    const url = `${protocol}://${host}/${path}`;

    return url;
};

export default getLoggingServiceEndpointURL;
